import { render, staticRenderFns } from "./NoteFilter.vue?vue&type=template&id=2a5879e3&"
import script from "./NoteFilter.vue?vue&type=script&lang=ts&"
export * from "./NoteFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports